import React from "react";
import { useObserver } from "mobx-react";
import { useState } from "react";
import { useStores } from "../../store";
import { AiFillCloseCircle } from "react-icons/ai";
import { IoIosArrowBack } from "react-icons/io";
import { useEffect } from "react";
import { toJS } from "mobx";
export default function CompanyBasedInnterview({
  popUpInitialValue,
  handlePopup,
}) {
  const { PopupStore, InterviewStore } = useStores();
  const [data, setData] = useState([]);
  const [company, setCompany] = useState({});
  const [currentCompany, setCurrentCompany] = useState(false);
  const closeThisPopUP = () => {
    PopupStore.setCompanyBasedInterview(false);
    handlePopup();
  };

  useEffect(() => {
    InterviewStore.geetingCompanyBasedInterviewData();
    setData(InterviewStore.companieslist);
  }, []);

  const viewRoles = (index, name) => {
    console.log(index);
    setCompany(InterviewStore.companieslist[index]);
    setCurrentCompany(true);
    const companyName = toJS(name?.companyName) || "";
    InterviewStore.setCompanyName(companyName);
    console.log(companyName);
  };

  const settingRole = (index, name) => {
    const rolename = toJS(name?.name) || "";
    InterviewStore.setRole(rolename);
    console.log(rolename);
  };

  return useObserver(() => (
    <>
      <div onClick={() => closeThisPopUP} className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
        <div onClick={(e) => e.stopPropagation()} className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[85%] lg:w-[85%] w-[90%] h-[95vh] m-auto shadow-lg overflow-y-auto no-scrollbar">
          <div className="flex flex-col  items-center w-[100%] h-full py-5 ">
            <AiFillCloseCircle
              className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
              onClick={closeThisPopUP}
            />

            <h1 className="font-bold gil-med text-3xl w-full opacity-75 px-10">
              Take mock interview on your dream company
            </h1>
            {currentCompany ? (
              <p
                className="absolute top-16 left-10 font-medium opacity-80 flex text-2xl items-center cursor-pointer"
                onClick={() => setCurrentCompany(false)}
              >
                {" "}
                <IoIosArrowBack className="text-2xl" /> Back{" "}
              </p>
            ) : (
              <div className=" flex flex-wrap h-[100%] gap-3 mt-10 w-[90%]  mx-auto">
                {InterviewStore.companieslist.map((item, index) => (
                  <div className="border-2 border-orange-400 h-60 w-[30%] mx-2 my-3 flex flex-col  items-center">
                    <img
                      src={item.img}
                      className="w-40 mt-10 h-[30%] cover "
                      alt=""
                    />
                    <p className="font-medium opacity-80 text-xl mt-2 text-center">
                      interviews on <br />{" "}
                    </p>
                    <p
                      className="underline text-orange-400 mt-5 text-xl cursor-pointer"
                      onClick={() => viewRoles(index, item)}
                    >
                      View all
                    </p>
                  </div>
                ))}
              </div>
            )}

            {currentCompany ? (
              <div className="flex flex-wrap h-[100%] gap-3 mt-10 w-[90%]  mx-auto">
                {company?.roles.map((item, index) => (
                  <div
                    className="border-2 border-orange-400 h-60 w-[30%] mx-2 my-3 flex flex-col  items-center"
                    onClick={() => settingRole(index, item)}
                  >
                    <img
                      src={item.img}
                      className="w-40 mt-10 h-[55%] cover"
                      alt=""
                    />
                    <p className="font-medium opacity-80 text-xl mt-2 text-center">
                      {" "}
                      {item.name}{" "}
                    </p>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  ));
}
